import i18n from "i18n";

const Messages = {
  Create: i18n.t('notifications.common.create', { dataType: i18n.t('labels.document') }),
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.document') }),
  Delete: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.document') }),
  Process: i18n.t('notifications.dmsDocuments.process')
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Create = i18n.t('notifications.common.create', { dataType: i18n.t('labels.document') });
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.document') });
  Messages.Delete = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.document') });
  Messages.Process = i18n.t('notifications.dmsDocuments.process');
});